import { Context } from '@nuxt/types';

export default async function(context: Context) {
  const { redirect } = context;

  await context.store.dispatch('profile/getUserData');

  if (context.store.state.profile.user.role !== 'admin') {
    redirect('/');
  }
}
